<template>
  <div class="background imgwrap">
    <div v-show="beautyFlag" class="duibi" @touchstart="tsbol=true" @touchend="tsbol=false">
      <img src="@/assets/duibi.png" class="db"/>
    </div>
    <div class="datawrap" :class="[showColorFlag||showBeautyFlag||showClothesFlag?'mt88':'']">
      <div v-if="color&&color[coloridx]&&color[coloridx].s_color" :style="{'background-image':'linear-gradient(to bottom,#'+color[coloridx].s_color+',#'+color[coloridx].e_color+')'}">
        <img :src="wm_url" class="prople" :class="[tsbol?'disnone':'']"/>
        <img :src="wm_url_no" class="prople" :class="[tsbol?'':'disnone']"/>
      </div>
      <div v-show="!showColorFlag&&!showBeautyFlag&&!showClothesFlag">
        <div v-if="pw&&ph">
          <div class="ku topleft"></div>
          <div class="ku topright"></div>
          <div class="ku bottomleft"></div>
          <div class="ku bottomright"></div>
        </div>
        <div class="pw" v-if="pw">{{pw}} px</div>
        <div class="ph" v-if="ph">{{ph}} px</div>
        <div class="w" v-if="w>0">{{w}} mm</div>
        <div class="h" v-if="h>0">{{h}} mm</div>
      </div>
    </div>
    <div class="addfont" v-if="is_word === 1" @click="fontShow=true">添加文字</div>
    <div class="font">
      <div class="fotitem" @click="showColorFlag=true">
        <img src="@/assets/hds.png" class="fotimg" />
        换底色
      </div>
      <div class="fotitem" @click="showBeautyFlag=true">
        <img src="@/assets/my.png" class="fotimg"/>
        美颜
      </div>
      <div class="fotitem" @click="showClothesFlag=true">
        <img src="@/assets/hz.png" class="fotimg"/>
        换装
        <img src="@/assets/zz.png" class="zzimg"/>
      </div>
      <div class="baocun">
        <div class="btn" @click="save">保存</div>
      </div>
    </div>
    <change-color :showFlag="showColorFlag"
                  :color="color"
                  @onControlColor="showColorFlag=false"
                  :coloridx="coloridx"
                  @onSetidx="onSetidx">
    </change-color>
    <beauty :showFlag="showBeautyFlag"
            @onBeautyClose="showBeautyFlag=false"
            :meiyanVal="meiyanVal"
            @onDoMeiyan="onDoMeiyan"
            :beautyFlag="beautyFlag"
            @onIsMeiyan="onIsMeiyan"
            @onCancel="onCancelMeiyan"
            @onNoneBeauty="showBeautyFlag=false">
    </beauty>
    <changeclose :showFlag="showClothesFlag"
                 @onCloseClothes="showClothesFlag=false"
                 :chooseKey="chooseKey"
                 :closes="closes"
                 @onChooseClothes="onChooseClothes"
                 @onInitVal="onInitKey"
                 @onCloseKey="showClothesFlag=false">
    </changeclose>
    <div v-show="fontShow">
      <ta :txt="inputValue"
          @onIpt="inputValueipt"
          @onSureTxt="onSureTxt"
          @onClose="ontxtClose"></ta>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import changeColor from '@/components/changeColor'
import beauty from '@/components/beauty'
import changeclose from '@/components/changeclose/changeclose'
import txtarea from '@/components/txtarea'
export default {
  data () {
    return {
      tsbol: false,
      showColorFlag: false,
      showBeautyFlag: false,
      showClothesFlag: false,
      beautyFlag: true, // 默认美颜
      w: 0,
      h: 0,
      rpw: 0, // rpx的图片宽度
      rph: 0, // rpx的图片高度
      pw: 0,
      ph: 0,
      color: [],
      coloridx: 0,
      wm_url: '',
      wm_url_no: '',
      meiyanVal: {},
      chooseKey: '', // 选择正装key值
      closes: {},
      inputValue: '',
      fontShow: false,
      is_word: 0 // 规格是否需要加字
    }
  },
  deactivated () {
    this.showColorFlag = false
    this.showBeautyFlag = false
    this.showClothesFlag = false
    this.fontShow = false
  },
  activated () {
    if (!this.actiBol) {
      return
    }
    this.inimeobj()
    this.getClothes()
    this.initData()
    this.setTitle()
    this.getMeiyandata()
  },
  created () {
    this.$bus.on('bk_openclose', this.hzFn)
  },
  destroyed () {
    this.$bus.off('bk_openclose')
  },
  computed: {
    ...mapState(['makePhotoInfo', 'beauty_default', 'actiBol'])
  },
  methods: {
    ...mapMutations(['setMakePhotoInfo', 'delPageStack']),
    ...mapActions(['getClothesA', 'makephoto_v2A']),
    hzFn () {
      this.showClothesFlag = true
    },
    inimeobj () {
      this.meobj = {
        defaultmy: {}, // 默认美颜值
        isMei: false, // 是否调过美颜，没有调过点击×不做任何处理
        nowMy: {} // 用户修改多美艳数据保存用于关闭美颜再开启美颜还原
      }
    },
    onSetidx (idx) {
      this.coloridx = idx
    },
    setTitle () {
      const { specName } = this.makePhotoInfo
      document.title = specName || '编辑'
    },
    inputValueipt (e) {
      const { value } = e.target
      this.inputValue = value
    },
    getMeiyandata (obj) {
      const meiyan = obj || this.beauty_default
      const myval = {}
      meiyan.forEach(item => {
        item.val.forEach(it => {
          myval[it.en] = it.val
        })
      })
      this.meobj.defaultmy = this.meobj.nowMy = { ...myval }
      const makePhotoInfo = {
        ...this.makePhotoInfo,
        ...myval
      }
      this.setMakePhotoInfo(makePhotoInfo)
      this.meiyanVal = myval
    },
    ontxtClose () {
      const val = this.makePhotoInfo.inputVal
      this.fontShow = false
      this.inputValue = val
    },
    save () {
      const { coloridx, chooseKey } = this
      let makePhotoInfo = this.makePhotoInfo
      makePhotoInfo = {
        ...this.makePhotoInfo,
        coloridx,
        clothes_path: chooseKey
      }
      this.setMakePhotoInfo(makePhotoInfo)
      const { project_no } = makePhotoInfo
      this.delPageStack('Joinpreview')
      this.$router.push({
        name: 'Joinpreview'
      })
    },
    onDoMeiyan (obj) {
      const { name, val } = obj
      const myval = this.meiyanVal
      myval[name] = val
      this.meobj.nowMy = myval // 保存美颜操作
      this.beautyHttp(myval)
    },
    onIsMeiyan (bol) {
      const beautyFlag = this.beautyFlag
      if (beautyFlag === bol) {
        return
      }
      let obj = bol ? this.meobj.nowMy : {
        leyelarge: 0,
        reyelarge: 0,
        mouthlarge: 0,
        skinwhite: 0,
        skinsoft: 0,
        coseye: 0,
        facelift: 0
      }
      const bubol = this.bumeiyan(obj)
      if (bubol && bol) {
        console.log('初始化美颜吧')
        obj = this.meobj.defaultmy
        console.log(obj)
        this.meobj.nowMy = obj
      }
      this.beautyHttp(obj).then(res => {
        console.log(obj)
        this.beautyFlag = bol
      })
    },
    onInitKey () {
      this.onChooseClothes('', true)
    },
    onSureTxt () {
      const { inputValue } = this
      const val = this.makePhotoInfo.inputVal
      inputValue !== val && this.fontmake(inputValue)
      this.fontShow = false
    },
    fontmake (fontval) {
      const {
        clothes_path,
        leyelarge,
        reyelarge,
        mouthlarge,
        skinwhite,
        skinsoft,
        coseye,
        facelift
      } = this.makePhotoInfo
      const obj = {
        ...fontval && { inputVal: fontval },
        ...leyelarge !== undefined && {
          leyelarge,
          reyelarge,
          mouthlarge,
          skinwhite,
          skinsoft,
          coseye,
          facelift
        },
        ...clothes_path && { clothes_path }
      }
      return this.makephoto_v2A(obj).then(res => {
        const { algo_fileuuid, wm_url } = res
        const makePhotoInfo = {
          ...this.makePhotoInfo,
          algo_fileuuid,
          wm_url,
          algo_filename_no_fm: clothes_path ? '' : algo_fileuuid, // 换了正装再美颜清除不换正装相对路径
          wm_url_nofm: clothes_path ? '' : wm_url,
          ...obj,
          inputVal: fontval
        }
        this.wm_url = wm_url
      })
    },
    onChooseClothes (key, closebol) {
      const {
        leyelarge,
        reyelarge,
        mouthlarge,
        skinwhite,
        skinsoft,
        coseye,
        facelift
      } = this.makePhotoInfo
      const { inputValue } = this
      const obj = {
        ...key && { clothes_path: key },
        ...leyelarge !== undefined && {
          leyelarge,
          reyelarge,
          mouthlarge,
          skinwhite,
          skinsoft,
          coseye,
          facelift
        },
        ...inputValue && { inputVal: inputValue }
      }
      this.makephoto_v2A(obj).then(res => {
        const { algo_fileuuid, wm_url } = res
        const makePhotoInfo = this.makePhotoInfo
        makePhotoInfo.algo_fileuuid = algo_fileuuid
        makePhotoInfo.wm_url = wm_url
        if (!key) {
          makePhotoInfo.algo_filename_no_fm = algo_fileuuid
          makePhotoInfo.wm_url_nofm = wm_url
        }
        makePhotoInfo.clothes_path = key
        this.setMakePhotoInfo(makePhotoInfo)
        this.setData({
          chooseKey: key,
          wm_url,
          ...closebol && {
            showClothesFlag: false
          }
        })
      })
    },
    onCancelMeiyan () {
      if (!this.meobj.isMei) {
        this.showBeautyFlag = false
        return
      }
      // 还原最初基础美颜
      const myval = this.meobj.defaultmy
      this.beautyHttp(myval, true)
    },
    pan0 (obj) {
      const bol = Object.keys(obj).some(item => {
        return obj[item] !== 0
      })
      return bol
    },
    beautyHttp (myval, needclose) {
      const { clothes_path } = this.makePhotoInfo
      const { inputValue } = this
      const obj = {
        ...clothes_path && { clothes_path },
        ...myval,
        ...inputValue && { inputVal: inputValue }
      }
      const beautyFlag = this.pan0(myval)
      return this.makephoto_v2A(obj).then(res => {
        if (!this.meobj.isMei) {
          this.meobj.isMei = true // 用户修改过美颜
        }
        if (needclose) {
          this.meobj.isMei = false // 用户修改过美颜再重置回最初美颜状态
        }
        const { algo_fileuuid, wm_url } = res
        const makePhotoInfo = {
          ...this.makePhotoInfo,
          algo_fileuuid,
          wm_url,
          ...obj,
          algo_filename_no_fm: obj.clothes_path ? '' : algo_fileuuid, // 换了正装再美颜清除不换正装相对路径
          wm_url_nofm: obj.clothes_path ? '' : wm_url
        }
        this.setMakePhotoInfo(makePhotoInfo)
        this.setData({
          wm_url,
          meiyanVal: myval,
          beautyFlag,
          ...needclose && { showBeautyFlag: false }
        })
      })
    },
    bumeiyan (obj) {
      const bol = Object.keys(obj).every(item => {
        return obj[item] === 0
      })
      return bol
    },
    initData () {
      const {
        clothes_path: chooseKey,
        width_px: pw,
        height_px: ph,
        wm_url,
        wm_url_no,
        height_mm: h,
        width_mm: w,
        background_color: color,
        coloridx,
        is_word
      } = this.makePhotoInfo
      console.log('有没有颜色', this.makePhotoInfo, color)
      const obj = this.pw2rpw(pw, ph)
      this.setData({
        ...obj,
        chooseKey,
        pw,
        ph,
        wm_url,
        wm_url_no,
        h,
        w,
        color,
        is_word
      })
    },
    pw2rpw (pw, ph) {
      const bili = 750 / window.screen.availWidth
      const rpw = pw * bili
      const rph = ph * bili
      return { rpw, rph }
    },
    setData (obj) {
      Object.keys(obj).forEach(item => {
        this[item] = obj[item]
      })
    },
    getClothes () {
      this.getClothesA().then(res => {
        console.log(res)
        this.closes = res.result
      })
    }
  },
  components: {
    changeColor,
    beauty,
    changeclose,
    ta: txtarea
  }
}
</script>

<style scoped>
.background{
  background-image: url("~@/assets/bbg.png");
  background-size: cover;
  padding:0 0 1.8rem;
  box-sizing: border-box;
  min-height: 100%;
}
.disnone{
  display: none!important;
}
.imgwrap{
  text-align: center;
}
.prople{
  display: block;
  width:4.72rem;
}
.datawrap{
  display: inline-block;
  padding: .48rem;
  position:relative;
  font-size: .26rem;
  color:#303133;
  margin-top: 1.14rem;
}
.mt88{
  margin-top: .4rem;
}
.valcls{
  text-align: center;
  height:.64rem;
  line-height: .64rem;
  font-size: .34rem;
  color:#303133;
  background-color: white;
}
.addfont{
  width:1.6rem;
  height:.64rem;
  background-color: white;
  border-radius: .12rem;
  text-align: center;
  line-height: .64rem;
  font-size: .24rem;
  color:#303133;
  margin: .2rem auto 0;
}
.ku{
  position:absolute;
  width:.26rem;
  height:.26rem;
  border-radius: 50%;
  box-sizing: border-box;
  border:.04rem solid #4710ED;
  /* display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center; */
}
.ku::before{
  display: block;
  content:'';
  width:1.44rem;
  height:1px;
  background-color: black;
  opacity: 0.6;
  border-radius: 1px;
  position: absolute;
  left:.22rem;
  top:50%;
  transform: translateY(-50%);
  transform: -webkit-translateY(-50%);
}
.ku::after{
  display: block;
  content:'';
  height:1.44rem;
  width:1px;
  background-color: black;
  opacity: 0.6;
  border-radius: 1px;
  position: absolute;
  top:.22rem;
  left:50%;
  transform: translateX(-50%);
  transform: -webkit-translateX(-50%);
}
.topleft{
  left:0;
  top:0;
}
.topright{
  right:0;
  top:0;
  transform: rotate(90deg);
}
.bottomleft{
  left:0;
  bottom:0;
  transform: rotate(-90deg);
}
.bottomright{
  right:0;
  bottom:0;
  transform: rotate(180deg);
}
.pw{
  position: absolute;
  top:0;
  left:50%;
  transform: translateX(-50%);
  transform: -webkit-translateX(-50%);
}
.ph{
  position: absolute;
  left:-.26rem;
  top:50%;
  transform:translateY(-50%) rotate(90deg);
}
.w{
  position: absolute;
  bottom:0;
  left:50%;
  transform: translateX(-50%);
  transform: -webkit-translateX(-50%);
}
.h{
  position: absolute;
  right:-.26rem;
  top:50%;
  transform:translateY(-50%) rotate(90deg);
}
.font{
  position:fixed;
  bottom:0;
  width:100%;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  height: 1.6rem;
  box-sizing: border-box;
  padding-left: .34rem;
}
.fotitem{
  flex-shrink: 0;
  text-align: center;
  font-size: .24rem;
  font-weight: bold;
  color:#303133;
  padding:0 .32rem;
  position:relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height:100%;
}
.zzimg{
  width:.64rem;
  position: absolute;
  right:-.12rem;
  top:.2rem;
}
.fotimg{
  width:.56rem;
  display: block;
  margin-bottom: .12rem;
}
.baocun{
  flex-shrink: 0;
  align-self: flex-end;
  height:100%;
  width:2.4rem;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  box-shadow: -.1rem 0 .52rem #F2F1F6;
}
.btn{
  width:1.44rem;
  height:.88rem;
  border-radius: .12rem;
  background-color: #4710ED;
  line-height: .88rem;
  text-align: center;
  font-size: .34rem;
  border-radius: .12rem;
  color:white;
}
.activebtn{
  background-color: rgba(71,16,237,0.6);
}
.db{
  width:.48rem;
}
.duibi{
  width:.96rem;
  height:.96rem;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 0 .3rem rgba(0,0,0,0.5);
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  position:absolute;
  top:.32rem;
  right:.32rem;
}
</style>
